// extracted by mini-css-extract-plugin
export default {"buttonscontainer":"buttonsmenu_buttonscontainer__tk088","button":"buttonsmenu_button__z3czp"};